import {findMeasurementImage} from './findMeasurementImage'
import {getSizesAndWidths} from './getSizesAndWidths'
import {temporaryFormatMeasures} from './temporaryFormatMeasuresForForm'

export const formatProductForForm = product => {
  if (!product) return undefined

  const {
    isB2c,
    productTypeId,
    mainCategoryId,
    // subCategory,
    subCategoryId,
    packageDepth,
    packageHeight,
    packageWeight,
    packageWidth,
    productTranslation,
    productCharacteristicValue,
    productTechnology,
    categoryId,
    productImage,
    referenceCode
  } = product?.productPropertiesSection || {}

  const nameAndDescriptionValues =
    productTranslation?.reduce((acc, item) => {
      if (item.name || item.description) {
        acc.push({
          languageId: item.languageId,
          name: item.name || '',
          description: item.description || ''
        })
      }
      return acc
    }, []) || []

  const formatedTechnologies = productTechnology?.map(
    technology => technology.technology
  )

  const formatedCharacteristics = productCharacteristicValue?.map(
    characteristic => {
      const {characteristicId, characteristic: characteristicObject} =
        characteristic.characteristicValue

      return {
        characteristicId: characteristicId,
        characteristicTranslation:
          characteristicObject.characteristicTranslation,
        characteristicValueId: characteristic.characteristicValueId
      }
    }
  )

  const SEOValues =
    productTranslation?.reduce((acc, item) => {
      if (item.metaTitle || item.metaDescription) {
        acc.push({
          languageId: item.languageId,
          metaTitle: item.metaTitle || '',
          metaDescription: item.metaDescription || ''
        })
      }
      return acc
    }, []) || []

  {
    /*
    TODO this should be removed once the backend is updated and 
    the values are returned in the correct format    
    */
  }

  const formattedProductMeasures = temporaryFormatMeasures(
    product?.productMeasureSection?.productMeasure
  )

  const {uniqueSizes, uniqueWidths} =
    getSizesAndWidths(product?.productSKUSection?.productCombination) || {}

  const {measurementImage, hasInitialMeasurementImage} = findMeasurementImage(
    product?.productPropertiesSection?.productImage
  )

  const productMeasuresSection = {
    measurements: formattedProductMeasures,
    measurementImage,
    hasInitialMeasurementImage,
    sizes: uniqueSizes,
    widths: uniqueWidths
  }

  return {
    propertiesSection: {
      business: isB2c,
      type: productTypeId,
      gender: mainCategoryId,
      category: categoryId,
      subCategory: subCategoryId,
      characteristics: formatedCharacteristics,
      technologies: formatedTechnologies,
      packageDepth: packageDepth,
      packageHeight: packageHeight,
      packageWeight: packageWeight,
      packageWidth: packageWidth,
      nameAndDescription: nameAndDescriptionValues,
      seo: SEOValues,
      productImage,
      referenceCode
    },
    skuSection: product?.productSKUSection,
    measuresSection: productMeasuresSection
  }
}
